import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Tags, Settings, Image as ImageIcon, MessageSquareQuote, Briefcase, LogOut, Store, CreditCard, FileText, FileQuestion, HelpCircle, Users, ScrollText } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  if (loading) return <div className="admin min-h-screen bg-background" />;
  if (!user || user.role !== "admin") return <Navigate to="/admin/login" replace />;

  const links = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
    { to: "/admin/wholesale", label: "Wholesale", icon: Briefcase },
    { to: "/admin/payments", label: "Payment Methods", icon: CreditCard },
    { to: "/admin/invoices", label: "Invoice Settings", icon: FileText },
    { to: "/admin/attributes", label: "Attributes", icon: Tags },
    { to: "/admin/banners", label: "Banners", icon: ImageIcon },
    { to: "/admin/testimonials", label: "Testimonials", icon: MessageSquareQuote },
    { to: "/admin/pages", label: "Content Pages", icon: FileQuestion },
    { to: "/admin/faqs", label: "FAQs", icon: HelpCircle },
    { to: "/admin/users", label: "Users", icon: Users },
    { to: "/admin/activity-logs", label: "Activity Logs", icon: ScrollText },
    { to: "/admin/settings", label: "Settings", icon: Settings },
  ];

  return (
    <div className="admin min-h-screen bg-background text-foreground flex">
      <aside className="w-60 shrink-0 border-r border-border bg-card hidden md:flex flex-col">
        <div className="p-6">
          <div className="font-display text-xl font-extrabold text-primary">BODYCRUSH</div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">Admin Console</p>
        </div>
        <nav className="px-3 space-y-1 flex-1">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors ${isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary hover:text-foreground"}`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 space-y-1">
          <button onClick={() => nav("/")} className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm w-full text-muted-foreground hover:bg-secondary" data-testid="admin-view-store"><Store className="w-4 h-4" /> View Store</button>
          <button onClick={() => { logout(); nav("/admin/login"); }} className="flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm w-full text-muted-foreground hover:bg-secondary" data-testid="admin-logout"><LogOut className="w-4 h-4" /> Log out</button>
        </div>
      </aside>
      <main className="flex-1 overflow-x-hidden">
        <div className="md:hidden flex items-center gap-2 p-3 border-b border-border overflow-x-auto bg-card">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => `flex items-center gap-1.5 px-3 py-2 rounded-full text-xs font-medium whitespace-nowrap ${isActive ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground"}`}>
              <l.icon className="w-3.5 h-3.5" /> {l.label}
            </NavLink>
          ))}
        </div>
        <div className="p-4 sm:p-8"><Outlet /></div>
      </main>
    </div>
  );
}
